"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockArticleList = void 0;
const ArticleList_1 = require("./ArticleList");
const ArticleUtils_1 = require("./ArticleUtils");
const MockArticle_1 = require("./MockArticle");
class MockArticleList extends ArticleList_1.ArticleList {
    clone() {
        const list = new MockArticleList();
        list.fromJson(this.toJson());
        return list;
    }
    fromJson(json) {
        this.items = [];
        for (const itemJson of json) {
            const article = new MockArticle_1.MockArticle();
            article.fromJson(itemJson);
            this.items.push(article);
        }
        this.emitChange();
    }
    toJson() {
        const json = [];
        for (const item of this.items) {
            json.push(item.toJson());
        }
        return json;
    }
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
    fromModel(_model) { }
    toModel() {
        return [];
    }
}
exports.MockArticleList = MockArticleList;
//# sourceMappingURL=MockArticleList.js.map